import {RetainerResistanceWithCode} from "../functions/types";

export const retainerResistance: RetainerResistanceWithCode[] = [
    {
        retainerCode: '040258',
        dist400: 37.5,
        dist500: 31.6,
        dist600: 25.7,
        dist700: 19.8,
        dist800: 13.9,
        dist900: 11.2,
        dist1000: 8.5
    },
    {
        retainerCode: '040259',
        dist400: 37.5,
        dist500: 31.6,
        dist600: 25.7,
        dist700: 19.8,
        dist800: 13.9,
        dist900: 11.2,
        dist1000: 8.5
    },
    {
        retainerCode: '020046',
        dist400: 24.0,
        dist500: 12.5,
        dist600: 7.1,
        dist700: 5.2,
        dist800: 3.5,
        dist900: 2.4,
        dist1000: 1.8
    },
    {
        retainerCode: '020017',
        dist400: 30.0,
        dist500: 24.0,
        dist600: 18.2,
        dist700: 12.3,
        dist800: 6.4,
        dist900: 3.7,
        dist1000: 2.0
    },
    {
        retainerCode: '020042',
        dist400: 30.0,
        dist500: 24.0,
        dist600: 18.2,
        dist700: 12.3,
        dist800: 6.4,
        dist900: 3.7,
        dist1000: 2.0
    },
    {
        retainerCode: '020036',
        dist400: 24.0,
        dist500: 12.5,
        dist600: 7.1,
        dist700: 5.2,
        dist800: 3.5,
        dist900: 2.4,
        dist1000: 1.8
    },
    {
        retainerCode: '020001',
        dist400: 4.5,
        dist500: 2.6,
        dist600: 1.6,
        dist700: 0.9,
        dist800: 0.7,
        dist900: 0.4,
        dist1000: 0.3
    },
    {
        retainerCode: '020019',
        dist400: 4.5,
        dist500: 2.6,
        dist600: 1.6,
        dist700: 0.9,
        dist800: 0.7,
        dist900: 0.4,
        dist1000: 0.3
    },
    {
        retainerCode: '020027',
        dist400: 6.1,
        dist500: 3.7,
        dist600: 2.2,
        dist700: 1.7,
        dist800: 1.2,
        dist900: 0.8,
        dist1000: 0.6
    },
    {
        retainerCode: '020003',
        dist400: 10.5,
        dist500: 6.6,
        dist600: 4.1,
        dist700: 2.9,
        dist800: 2.2,
        dist900: 1.5,
        dist1000: 1.2
    },
    {
        retainerCode: '020020',
        dist400: 10.5,
        dist500: 6.6,
        dist600: 4.1,
        dist700: 2.9,
        dist800: 2.2,
        dist900: 1.5,
        dist1000: 1.2
    },
    {
        retainerCode: '020005',
        dist400: 12.9,
        dist500: 7.9,
        dist600: 4.8,
        dist700: 3.6,
        dist800: 1.9,
        dist900: 1.3,
        dist1000: 1.0
    },
    {
        retainerCode: '020006',
        dist400: 13.9,
        dist500: 9.0,
        dist600: 5.9,
        dist700: 4.2,
        dist800: 3.2,
        dist900: 2.2,
        dist1000: 1.6
    },
    {
        retainerCode: '020022',
        dist400: 13.9,
        dist500: 9.0,
        dist600: 5.9,
        dist700: 4.2,
        dist800: 3.2,
        dist900: 2.2,
        dist1000: 1.6
    },
    {
        retainerCode: '020028',
        dist400: 11.2,
        dist500: 7.1,
        dist600: 4.4,
        dist700: 2.9,
        dist800: 2.2,
        dist900: 1.6,
        dist1000: 1.2
    },
    {
        retainerCode: '020007',
        dist400: 13.9,
        dist500: 9.0,
        dist600: 5.9,
        dist700: 4.2,
        dist800: 3.2,
        dist900: 2.2,
        dist1000: 1.6
    },
    {
        retainerCode: '020023',
        dist400: 13.9,
        dist500: 9.0,
        dist600: 5.9,
        dist700: 4.2,
        dist800: 3.2,
        dist900: 2.2,
        dist1000: 1.6
    },
    {
        retainerCode: '020045',
        dist400: 12.9,
        dist500: 7.9,
        dist600: 4.8,
        dist700: 3.6,
        dist800: 1.9,
        dist900: 1.3,
        dist1000: 1.0
    },
    {
        retainerCode: '020039',
        dist400: 12.9,
        dist500: 7.9,
        dist600: 4.8,
        dist700: 3.6,
        dist800: 1.9,
        dist900: 1.3,
        dist1000: 1.0
    },
    {
        retainerCode: '020040',
        dist400: 12.9,
        dist500: 7.9,
        dist600: 4.8,
        dist700: 3.6,
        dist800: 1.9,
        dist900: 1.3,
        dist1000: 1.0
    }
]